"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = exports.BaseWalletAdapter = exports.WalletReadyState = exports.WalletAdapterNetwork = exports.WalletError = exports.WalletNotReadyError = exports.SignerWalletAdapter = exports.MessageSignerWalletAdapter = exports.TOKEN_PROGRAM_ID = exports.LAMPORTS_PER_SOL = exports.VersionedTransaction = exports.Transaction = exports.Connection = exports.Keypair = exports.PublicKey = exports.SystemProgram = void 0;
exports.isLegacyConnection = isLegacyConnection;
exports.isKitConnection = isKitConnection;
// Only re-export specific types that you actually need
var web3_js_1 = require("@solana/web3.js");
Object.defineProperty(exports, "PublicKey", { enumerable: true, get: function () { return web3_js_1.PublicKey; } });
Object.defineProperty(exports, "Connection", { enumerable: true, get: function () { return web3_js_1.Connection; } });
Object.defineProperty(exports, "Transaction", { enumerable: true, get: function () { return web3_js_1.Transaction; } });
Object.defineProperty(exports, "Keypair", { enumerable: true, get: function () { return web3_js_1.Keypair; } });
Object.defineProperty(exports, "VersionedTransaction", { enumerable: true, get: function () { return web3_js_1.VersionedTransaction; } });
Object.defineProperty(exports, "LAMPORTS_PER_SOL", { enumerable: true, get: function () { return web3_js_1.LAMPORTS_PER_SOL; } });
var web3_js_2 = require("@solana/web3.js");
Object.defineProperty(exports, "SystemProgram", { enumerable: true, get: function () { return web3_js_2.SystemProgram; } });
var spl_token_1 = require("@solana/spl-token");
Object.defineProperty(exports, "TOKEN_PROGRAM_ID", { enumerable: true, get: function () { return spl_token_1.TOKEN_PROGRAM_ID; } });
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
Object.defineProperty(exports, "WalletAdapterNetwork", { enumerable: true, get: function () { return wallet_adapter_base_1.WalletAdapterNetwork; } });
Object.defineProperty(exports, "WalletError", { enumerable: true, get: function () { return wallet_adapter_base_1.WalletError; } });
Object.defineProperty(exports, "WalletNotReadyError", { enumerable: true, get: function () { return wallet_adapter_base_1.WalletNotReadyError; } });
Object.defineProperty(exports, "WalletReadyState", { enumerable: true, get: function () { return wallet_adapter_base_1.WalletReadyState; } });
Object.defineProperty(exports, "BaseWalletAdapter", { enumerable: true, get: function () { return wallet_adapter_base_1.BaseWalletAdapter; } });
Object.defineProperty(exports, "EventEmitter", { enumerable: true, get: function () { return wallet_adapter_base_1.EventEmitter; } });
Object.defineProperty(exports, "MessageSignerWalletAdapter", { enumerable: true, get: function () { return wallet_adapter_base_1.BaseMessageSignerWalletAdapter; } });
Object.defineProperty(exports, "SignerWalletAdapter", { enumerable: true, get: function () { return wallet_adapter_base_1.BaseSignerWalletAdapter; } });
// Export all wallet-standard types
__exportStar(require("./wallet-standard-types"), exports);
/**
 * Helper to detect if a connection is a legacy Connection from @solana/web3.js
 */
function isLegacyConnection(connection) {
    return (connection !== null &&
        typeof connection === 'object' &&
        'rpcEndpoint' in connection &&
        'commitment' in connection &&
        '_rpcRequest' in connection);
}
/**
 * Helper to detect if a connection is a Kit Rpc from @solana/kit
 */
function isKitConnection(connection) {
    return !isLegacyConnection(connection);
}
